import StaffEditPage from './StaffEditPage';

export default StaffEditPage;
